import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, CheckCircle, Settings, HardHat, Award, Users, Package } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { services } from '../mockData';

const iconMap = {
  FileText: FileText,
  CheckCircle: CheckCircle,
  Settings: Settings,
  HardHat: HardHat,
  Award: Award,
  Users: Users,
  Package: Package
};

const Services = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Our <span className="text-red-600">Services</span>
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-6" />
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            We provide a diverse range of professional services for the oil & gas industry
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            
            // Define which services have detail pages
            const serviceRoutes = {
              "Pre-Award Services": "/services/pre-award",
              "Post-Award Services": "/services/post-award",
              "Engineering Services": "/services/engineering",
              "Construction Services": "/services/construction",
              "Quality Management Services": "/services/quality-management",
              "Oil & Gas Professional's Enrichment & Mentoring": "/services/professional-enrichment",
              "Supply Chain Management": "/services/supply-chain"
            };
            
            const isClickable = serviceRoutes[service.title] !== undefined;
            const serviceLink = serviceRoutes[service.title] || "";
            
            const ServiceCard = (
              <Card
                key={service.id}
                className="group border-none shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden cursor-pointer bg-white"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent" />
                  <div className="absolute bottom-4 left-4 w-14 h-14 bg-blue-600 rounded-xl flex items-center justify-center">
                    <IconComponent className="w-7 h-7 text-white" />
                  </div>
                </div>
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-red-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">{service.description}</p>
                  <div className="mt-4 flex items-center text-red-600 font-semibold group-hover:gap-2 transition-all">
                    <span>Learn More</span>
                    <span className="transform group-hover:translate-x-2 transition-transform">→</span>
                  </div>
                </CardContent>
              </Card>
            );

            return isClickable ? (
              <Link key={service.id} to={serviceLink}>
                {ServiceCard}
              </Link>
            ) : (
              ServiceCard
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-slate-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-slate-900 mb-4">Need a Custom Solution?</h3>
            <p className="text-slate-600 mb-6 max-w-2xl">
              Our team can develop tailored engineering and project management solutions to meet your specific requirements.
            </p>
            <button className="px-8 py-3 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition-colors shadow-lg hover:shadow-xl">
              Contact Our Experts
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;